import React from "react"

const BlockSpan = ({ children, className }) => (
  <span className={`d-block ${className}`}>{children}</span>
)

export default BlockSpan
